import {
	FETCH_DIAGNOSTIQUES_BEGIN,
	FETCH_DIAGNOSTIQUES_ERROR,
	FETCH_DIAGNOSTIQUES_SUCCESS,
	FETCH_DIAG_TARIFS_SUCCESS,
} from "../actions/diagnostiqueActions"

// tree : { "-1": [menus rapides], "0": [racines], "<parentId>": [enfants] }
// tarifs : { "<diagId>": { "<entiteId>": {tarif, tarif_autre, texte_autre} } }
const initialState = {
	tree: {},
	tarifs: {},
	fetchDiagnostiques: { fetching: false, error: null },
}

export default function diagnostiqueReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_DIAGNOSTIQUES_BEGIN:
			return {
				...state,
				fetchDiagnostiques: { fetching: true, error: null },
			}
		case FETCH_DIAGNOSTIQUES_ERROR:
			return {
				...state,
				fetchDiagnostiques: {
					fetching: false,
					error: action.payload.error,
				},
			}
		case FETCH_DIAGNOSTIQUES_SUCCESS:
			return {
				...state,
				tree: action.payload.tree,
				fetchDiagnostiques: { fetching: false, error: null },
			}
		case FETCH_DIAG_TARIFS_SUCCESS:
			return { ...state, tarifs: action.payload.tarifs }
		default:
			return state
	}
}
